import * as sapStorage from "../../localStorage/sapReducer"

/**
 * Return the dynamic configuration value associated with the key stored in the store.
 */
export const getDynamicConfigurationValue = (state, key) =>
    sapStorage.getDynamicConfigurationValue(state.localStorage.sap, key)
